export { default as AssetsMenuTable } from './component';
